import React, { useEffect, useRef, useState } from 'react';
import { base44 } from '@/api/base44Client';

export default function EditableHeroImage({ page, heroGradient, onImageChange }) {
  const inputRef = useRef(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    base44.auth.isAuthenticated().then(async (authenticated) => {
      if (!authenticated) return;
      const user = await base44.auth.me();
      setIsAdmin(user?.role === 'admin');
    });
  }, []);

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    try {
      const { file_url } = await base44.integrations.Core.UploadFile({ file });
      await base44.entities.LandingPage.update(page.id, { hero_image_url: file_url });
      onImageChange(file_url);
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <button
      type="button"
      onClick={() => isAdmin && inputRef.current?.click()}
      className={`absolute inset-0 rounded-card-xl overflow-hidden text-left ${isAdmin ? 'cursor-pointer group' : 'cursor-default'}`}
      aria-label={isAdmin ? 'Αλλαγή φωτογραφίας landing page' : page.title}
    >
      {page.hero_image_url ? (
        <img
          src={page.hero_image_url}
          alt={page.title}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full" style={{ background: heroGradient }} />
      )}

      {isAdmin && (
        <div className="absolute inset-0 bg-warm-black/0 group-hover:bg-warm-black/35 transition-all duration-300 flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 transition-opacity bg-ivory text-warm-black rounded-pill px-5 py-3 text-body-s font-medium shadow-card">
            {uploading ? 'Ανεβαίνει...' : 'Κλικ για αλλαγή φωτογραφίας'}
          </span>
        </div>
      )}

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="hidden"
      />
    </button>
  );
}